module.exports = __webpack_public_path__ + "static/karla-bold-c1281ef0f090a6d5e0978edc2f09f4b5.woff";